// src/components/PersonalCocina.jsx
import React, { useState, useEffect } from "react";
import clienteAxios from "../../axios";
import ModalConfirm from "../ModalConfirm";
import ModalAgregarPersonalCocina from './ModalAgregarPersonalCocina'; // Importamos el nuevo modal



const PersonalCocina = ({ cocinaId }) => {
    const [personal, setPersonal] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [nuevoPersonal, setNuevoPersonal] = useState({ empleado_id: "", rol: "" });
    const [editandoPersonal, setEditandoPersonal] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [personalSeleccionado, setPersonalSeleccionado] = useState(null);
    const [mostrarPersonal, setMostrarPersonal] = useState(false); // Controla la visibilidad del personal
    const [nombreCocina, setNombreCocina] = useState(""); // Estado para almacenar el nombre de la cocina
    const [showAgregarPersonalModal, setShowAgregarPersonalModal] = useState(false);  // Estado para mostrar el modal


    // Función para obtener los datos de la cocina usando el cocinaId
    const obtenerCocina = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "cocinas"
            });

            const cocina = response.data.data[0].find(item => item.id === cocinaId);
            if (cocina) {
                setNombreCocina(cocina.nombre); // Almacenar el nombre de la cocina
            }
        } catch (error) {
            console.log(error);
        }
    };

    // Función para obtener el personal de cocina
    const obtenerPersonalCocina = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "personal_cocina"
            });
            setPersonal(response.data.data[0].filter(item => item.cocina_id === cocinaId));
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {        

        obtenerCocina(); // Llamamos la función para obtener los detalles de la cocina

    }, [cocinaId]);

    useEffect(() => {
        obtenerPersonalCocina();
    }, [cocinaId]);

    // Función para manejar la barra de búsqueda
    const handleBusqueda = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };

    const personalFiltrado = personal.filter(item =>
        item.rol.toLowerCase().includes(busqueda)
    );

    // Función para agregar nuevo personal
    const handleAgregarPersonal = async (e) => {
        e.preventDefault();
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "personal_cocina",
                cocina_id: cocinaId,
                empleado_id: nuevoPersonal.empleado_id,
                rol: nuevoPersonal.rol
            });
            setNuevoPersonal({ empleado_id: "", rol: "" });
            obtenerPersonalCocina(); // Actualizar lista
        } catch (error) {
            console.log(error);
        }
    };

    // Función para editar personal
    const editarPersonal = (personalItem) => {
        setEditandoPersonal(personalItem);
    };

    // Función para guardar personal editado
    const guardarPersonalEditado = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "personal_cocina",
                id: editandoPersonal.id,
                cocina_id: editandoPersonal.cocina_id,
                empleado_id: editandoPersonal.empleado_id,
                rol: editandoPersonal.rol
            });
            setEditandoPersonal(null);
            obtenerPersonalCocina(); // Actualizar lista
        } catch (error) {
            console.log(error);
        }
    };

    // Función para eliminar personal
    const confirmarEliminarPersonal = (personalItem) => {
        setPersonalSeleccionado(personalItem);
        setShowConfirmModal(true);
    };

    const eliminarPersonal = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminiar",
                modulo: "personal_cocina",
                id: personalSeleccionado.id
            });
            setShowConfirmModal(false);
            obtenerPersonalCocina(); // Actualizar lista
        } catch (error) {
            console.log(error);
        }
    };

    // Función para abrir el modal de agregar personal
    const handleAbrirAgregarPersonalModal = () => {
        setShowAgregarPersonalModal(true);
    };

    // Función para cerrar el modal de agregar personal
    const handleCerrarAgregarPersonalModal = () => {
        setShowAgregarPersonalModal(false);
    };

    return (
        <div>

            {/* Mostrar personal si el botón ha sido presionado */}
            <div className="mt-4 border p-4 rounded-lg">
                <h3 className="text-lg font-semibold">Personal de la Cocina: {nombreCocina}</h3>

                {/* Barra de búsqueda */}
                <input
                    type="text"
                    placeholder="Buscar rol..."
                    value={busqueda}
                    onChange={handleBusqueda}
                    className="border rounded-lg p-2 mb-4 mt-2 w-1/2 min-w-[200px]"
                />

                {/* Botón para abrir el modal de agregar personal */}
                <button
                    onClick={handleAbrirAgregarPersonalModal}
                    className="bg-blue-500 text-white px-4 py-2 rounded ml-2 hover:bg-blue-400"
                >
                    Agregar Nuevo Personal
                </button>

                <ul>
                    {personalFiltrado.map((item) => (
                        <li key={item.id} className="border p-2 mb-2 mt-4">
                            {editandoPersonal && editandoPersonal.id === item.id ? (
                                <>
                                <h3 className=" font-semibold mt-2">Rol:</h3>
                                    <input
                                        type="text"
                                        value={editandoPersonal.rol}
                                        onChange={(e) =>
                                            setEditandoPersonal({ ...editandoPersonal, rol: e.target.value })
                                        }
                                        className="border rounded-lg p-2 mr-2"
                                        maxLength={20}
                                    />
                                     <div className="flex mt-4 mb-2">
                                    <button
                                        onClick={guardarPersonalEditado}
                                        className="bg-green-500 text-white rounded px-2 py-1 mt-2 w-40"
                                    >
                                        Guardar
                                    </button>
                                    <button
                                        onClick={() => setEditandoPersonal(null)}
                                        className="bg-gray-500 text-white rounded px-2 py-1 mt-2 ml-2 w-40"
                                    >
                                        Cancelar
                                    </button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <span><strong>Empleado ID:</strong> {item.empleado_id}</span><br />
                                    <span><strong>Rol:</strong> {item.rol}</span><br />
                                    <button
                                        onClick={() => editarPersonal(item)}
                                        className="bg-gray-500 text-white rounded px-2 py-1 mt-2 hover:bg-gray-400"
                                    >
                                        Editar
                                    </button>
                                    <button
                                        onClick={() => confirmarEliminarPersonal(item)}
                                        className="bg-red-600 text-white rounded px-2 py-1 mt-2 ml-2 hover:bg-red-500"
                                    >
                                        Eliminar
                                    </button>
                                </>
                            )}
                        </li>
                    ))}
                </ul>
            </div>


            {/* Modal de confirmación */}
            <ModalConfirm
                show={showConfirmModal}
                message="¿Estás seguro de que quieres eliminar este personal?"
                onConfirm={eliminarPersonal}
                onCancel={() => setShowConfirmModal(false)}
            />


            {/* Modal para agregar nuevo personal */}
            <ModalAgregarPersonalCocina
                show={showAgregarPersonalModal}
                onClose={handleCerrarAgregarPersonalModal}
                cocinaId={cocinaId}
                onPersonalAgregado={obtenerPersonalCocina}  // Actualiza la lista de personal al agregar
            />
        </div>
    );
};

export default PersonalCocina;
